/* eslint-disable max-len */
export const required = (value) => (value ? undefined : 'Champ requis');
export const maxSize = (max) => (value) => (value.length >= max ? `Maximum ${max} characteres` : undefined);
export const composeValidators = (...validators) => (value) => validators.reduce((error, validator) => error || validator(value), undefined);
